import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { routesConfig } from './routes-config';
import PrivateRoute from './private-route';
import { NavigationPaths } from '../constants';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { LanguageSelector } from '../components';

const App: React.FC = () => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const location = useLocation();
  const currentRoute = routesConfig.find((route) => route.path === location.pathname);
  const hideLanguageSelector = currentRoute?.isPrivate;

  if (currentRoute && !currentRoute.isPrivate && isAuthenticated) {
    return (
      <Routes>
        <Route
          key={currentRoute?.path}
          path={currentRoute?.path}
          element={<Navigate to={NavigationPaths.ORGANISATION_USERS} />}
        />
      </Routes>
    );
  }
  return (
    <div>
      {!hideLanguageSelector && <LanguageSelector />}
      <Routes>
        {currentRoute ? (
          currentRoute.isPrivate && currentRoute.path !== NavigationPaths.NOT_FOUND ? (
            <Route
              key={currentRoute?.path}
              path={currentRoute?.path}
              element={<PrivateRoute>{currentRoute?.element}</PrivateRoute>}
            />
          ) : (
            <Route
              key={currentRoute?.path}
              path={currentRoute?.path}
              element={currentRoute?.element}
            />
          )
        ) : (
          <Route
            path="*"
            element={<Navigate to={NavigationPaths.NOT_FOUND} />}
          />
        )}
      </Routes>
    </div>
  );
};

export default App;
